import React, { forwardRef, useImperativeHandle } from 'react';
import Application from '../pdf/Application.pdf';
import { PDFDocument, rgb, StandardFonts } from 'pdf-lib';
import icon from '../All/images/tick-icon.png';
import { removeBracketedText } from '../Axiosinstance';
import notoSansSC from '../fonts/NotoSansSC-Regular.ttf';
import fontkit from '@pdf-lib/fontkit';

const ApplicationForm = forwardRef(({ dataProp, studentInfo }, ref) => {

    const handleDownload = async () => {
        try {
            const pdfBytes = await fetch(Application).then(res => res.arrayBuffer());
            const pdfDoc = await PDFDocument.load(pdfBytes);

            let image;
            const imageUrl = dataProp?.student.profileUrl || '';
            // const imageUrl = 'https://res.cloudinary.com/dyjwwi8ea/raw/upload/v1722238090/LMS/courses/pexels-mikebirdy-188777.jpg';
            // const imageResponse = await fetch(imageUrl);
            // const imageBytes = await imageResponse.arrayBuffer();

            // if (imageUrl) {
            //     // Fetch and embed the image
            //     const imageResponse = await fetch(imageUrl);
            //     const imageBytes = await imageResponse.arrayBuffer();

            //     if (imageUrl.endsWith('.png')) {
            //         image = await pdfDoc.embedPng(imageBytes);
            //     } else if (imageUrl.endsWith('.jpg') || imageUrl.endsWith('.jpeg')) {
            //         image = await pdfDoc.embedJpg(imageBytes);
            //     } else {
            //         throw new Error("Unsupported image format. Only PNG and JPG are supported.");
            //     }
            // }
            if (imageUrl) {
                try {
                    const img = new Image();
                    img.crossOrigin = "anonymous";
                    img.src = imageUrl;
                    await new Promise((resolve, reject) => {
                        img.onload = resolve;
                        img.onerror = () => reject(new Error("Image load failed"));
                    });

                    const canvas = document.createElement("canvas");
                    canvas.width = img.width;
                    canvas.height = img.height;
                    const ctx = canvas.getContext("2d");
                    ctx.drawImage(img, 0, 0);
                    const dataUrl = canvas.toDataURL("image/png");
                    const base64Data = dataUrl.split(",")[1];
                    const imageBytes = Uint8Array.from(
                        atob(base64Data),
                        c => c.charCodeAt(0)
                    );

                    image = await pdfDoc.embedPng(imageBytes);

                } catch (err) {
                    console.error("Image processing failed:", err);
                }
            }


            // Get the fifth page
            const pagess = pdfDoc.getPages();
            const fifthPages = pagess[4]; 

            // Draw the image on the fifth page
            if (image) {
                const { width, height } = fifthPages.getSize();
                fifthPages.drawImage(image, {
                    x: 452, // Adjust as needed
                    y: 629, // Adjust as needed
                    width: 100, // Adjust as needed
                    height: 95, // Adjust as needed
                });
            }


            // Access the pages
            const pages = pdfDoc.getPages();
            const firstPage = pages[0];
            const thirdPage = pages[2];
            const fourthPage = pages[3];
            const fifthPage = pages[4]; // Index 4 for the 5th page
            const sixthPage = pages[5]; // Index 5 for the 6th page
            const seventhPage = pages[6]; // Index 6 for the 7th page
            const tenthPage = pages[9];
            const eleventhPage = pages[10];
            // Set font and size
            const font = await pdfDoc.embedFont(StandardFonts.TimesRoman);

            pdfDoc.registerFontkit(fontkit);

            const fontResponse = await fetch(notoSansSC);
            const fontBytes = await fontResponse.arrayBuffer();

            const addressfont = await pdfDoc.embedFont(fontBytes);
            const fontSize = 11;

            // Extract values
            const nricRaw = dataProp.student?.nric || '';
            const sessionDateRaw = dataProp.courseFeeDetails?.[0]?.sessionDate || ''; // format: 'YYYY-MM-DD'
            const sequenceNumberRaw = dataProp.courseFeeDetails?.[0]?.sequenceNumber || 0;
            const sequenceNumber = String(sequenceNumberRaw).padStart(4, '0');

            // Parse date
            const sessionDate = new Date(sessionDateRaw);
            const year = sessionDate.getFullYear().toString().slice(-2); // Last 2 digits of year

            // Format components
            const prefix = 'JA';
            const formattedNric = `${nricRaw}`;

            // Combine all parts
            const formattedId = `${prefix}${year}-${sequenceNumber}-${formattedNric}`;


            // Data to insert
            const studentName = (dataProp?.student?.fullname || '').toUpperCase();
            const nric = nricRaw;
            const phone = dataProp?.handPhone || '';
            const email = dataProp.student?.email || '';
            const dob = dataProp.student?.dob || '';
            const formatDate = (dateString) => {
                const date = new Date(dateString);
                const day = String(date.getDate()).padStart(2, '0');
                const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are zero-based
                const year = date.getFullYear();
                return `${day}/${month}/${year}`;
            };

            const formattedDob = formatDate(dob);
          

            // const course = (dataProp?.batch?.course || '').toUpperCase().replace(/\s*\(1\)$/, '');
            const course = removeBracketedText((dataProp?.batch?.course || '')).toUpperCase();

            // const intakeId = (dataProp?.intakeId || '').toUpperCase().replace(/\s*\(1\)$/, '');
            const institutionDetails = dataProp?.institutionDetails || [];
            const gender = (dataProp?.gender || '').toUpperCase();
            const countryBirth = (dataProp?.countryBirth || '').toUpperCase();
            const nationality = (dataProp?.nationality || '').toUpperCase();
            const passportNo = dataProp?.passportNo || '';
            const company = (dataProp?.company || '').replace(/[\u200B-\u200D\uFEFF]/g, '').toUpperCase();
            const designation = (dataProp?.designation || '').toUpperCase();
            const addressOffice = (dataProp?.addressOffice || '').toUpperCase();
            const addressHome = (dataProp?.addressHome || '').toUpperCase();
            const phoneHome = dataProp?.phoneHome || '';
            const phoneOffice = dataProp?.phoneOffice || '';
            const emergencyName = (dataProp?.emergencyName || '').toUpperCase();
            const emergencyPhone = dataProp?.emergencyPhone || '';
            const emergencyRelation = (dataProp?.emergencyRelation || '').toUpperCase();
            const proofType = (dataProp?.proofType || '').toUpperCase(); // Retrieve proofType from dataProp
            const enrolleddate = dataProp?.enrolledDate || '';

            const KnowAboutProgram = (dataProp?.knowAboutProgram || '');
            const otherDetails = (dataProp?.otherDetails || '').toUpperCase();
            const referalfriend = (dataProp.referalfriend || '').toUpperCase();

            const courseFee = dataProp?.batch?.courseFee ? String(dataProp.batch.courseFee) : '';
            const type = (dataProp?.type || '').toUpperCase(); // Get type from dataProp
            const registrationfee = Number(dataProp?.batch?.registrationFee ?? 0).toFixed(2);
            const owner = 'CHIDAMBARAM PUSHPARANI';
            const dateforrender = dataProp?.scheduleDate[0]?.startDate;
            const alldate = formatDate(dataProp.late ? dateforrender : extractDate(dataProp?.paidDate));

            let approverText

            if (dataProp.approver.toLowerCase() === "admin") {
                // Assuming the name of the admin is stored in localStorage under the key 'adminName'
                approverText = localStorage.getItem('name') || dataProp.approver;
            } else {
                approverText = dataProp.approver;
            }


            const approver = (approverText).toUpperCase() || '';

            const basedongender = gender === 'MALE' ? 129 : 78;

            let paymentType = (dataProp?.paymentType || dataProp.courseFeeDetails[0].paymentMode || '').toUpperCase();
            if (paymentType === 'ONLINE') {
                paymentType = 'ONLINE BANKING';
            } else if (paymentType === 'OFFLINE') {
                paymentType = 'OFFLINE CASH';
            }
            // console.log('eee', type);
            // Determine the value to display based on type
            let displayValue = '';
            if (type === 'DIPLOMA') {
                displayValue = '12';
            } else if (type === 'ADVANCE_DIPLOMA') {
                displayValue = '6';
            }


            const getTextWidth = (text, font, fontSize) => {
                const width = font.widthOfTextAtSize(text, fontSize);
                return width;
            };


            function replaceTabs(text) {
                if (typeof text !== 'string') {
                    return ''; // Return an empty string if the input is not a valid string
                }
                return text.replace(/\t/g, '    '); // Replace each tab with four spaces
            }


            const drawWrappedText = async (page, text, x, y, font, fontSize, maxWidth) => {
                text = replaceTabs(text);
                const lines = [];
                let currentLine = '';
                const words = text.split(' ');

                for (let i = 0; i < words.length; i++) {
                    const word = words[i];
                    const width = getTextWidth(currentLine + ' ' + word, font, fontSize);

                    if (width < maxWidth) {
                        currentLine += (currentLine === '' ? '' : ' ') + word;
                    } else {
                        lines.push(currentLine.trim());
                        currentLine = word;
                    }
                }

                if (currentLine !== '') {
                    lines.push(currentLine.trim());
                }

                for (let i = 0; i < lines.length; i++) {
                    const line = lines[i].trim();
                    const lineWidth = getTextWidth(line, font, fontSize);

                    await page.drawText(line, {
                        x: i === 0 ? x : x,  // Keep the initial X position for all lines
                        y: y - i * 10,       // Adjust the line height as needed
                        size: fontSize,
                        font,
                        color: rgb(0, 0, 0),
                    });
                }
            };

            // Draw existing text on different pages
            // firstPage.drawText(studentName, { x: 130, y: firstPage.getHeight() - 119, size: 10, font, color: rgb(0, 0, 0), });
            drawWrappedText(firstPage, studentName, 130, fifthPage.getHeight() - 118, font, 9, 170);

            firstPage.drawText(nric, { x: 120, y: firstPage.getHeight() - 138, size: 10, font, color: rgb(0, 0, 0) });

            firstPage.drawText(alldate, { x: 300, y: firstPage.getHeight() - 138, size: 10, font, color: rgb(0, 0, 0), });

            // firstPage.drawText(approver, { x: 380, y: firstPage.getHeight() - 152, size: 10, font, color: rgb(0, 0, 0), });
            drawWrappedText(firstPage, approver, 375, fifthPage.getHeight() - 150, font, 9, 170);

            // Add text to the third page
            thirdPage.drawText(studentName, { x: 48, y: thirdPage.getHeight() - 350, size: fontSize, font, color: rgb(0, 0, 0), });

            if (proofType === 'NRIC') {
                const lineXStart = 80; // X position where the line starts
                const lineY = thirdPage.getHeight() - 376; // Y position where the line is drawn
                const lineLength = 35; // Length of the line

                thirdPage.drawLine({
                    start: { x: lineXStart, y: lineY },      // Starting point of the line
                    end: { x: lineXStart + lineLength, y: lineY }, // Ending point of the line
                    thickness: 2,  // Thickness of the line
                    color: rgb(0, 0, 0), // Line color
                });
            }
            else {
                const lineXStart = 47; // X position where the line starts
                const lineY = thirdPage.getHeight() - 376; // Y position where the line is drawn
                const lineLength = 25; // Length of the line

                thirdPage.drawLine({
                    start: { x: lineXStart, y: lineY },      // Starting point of the line
                    end: { x: lineXStart + lineLength, y: lineY }, // Ending point of the line
                    thickness: 2,  // Thickness of the line
                    color: rgb(0, 0, 0), // Line color
                });
            }


            //    for homemobile
            const lineXStart = 355; // X position where the line starts
            const lineY = thirdPage.getHeight() - 376; // Y position where the line is drawn
            const lineLength = 43; // Length of the line

            thirdPage.drawLine({
                start: { x: lineXStart, y: lineY },      // Starting point of the line
                end: { x: lineXStart + lineLength, y: lineY }, // Ending point of the line
                thickness: 2,  // Thickness of the line
                color: rgb(0, 0, 0), // Line color
            });


            // thirdPage.drawText(nric, { x: 144, y: thirdPage.getHeight() - 383, size: fontSize, font, color: rgb(0, 0, 0), });
            if (proofType === 'NRIC') {
                thirdPage.drawText(nric, { x: 144, y: thirdPage.getHeight() - 381, size: fontSize, font, color: rgb(0, 0, 0), });
            }
            else {
                thirdPage.drawText(passportNo, { x: 144, y: thirdPage.getHeight() - 381, size: fontSize, font, color: rgb(0, 0, 0), });
            }
            thirdPage.drawText(phone, { x: 423, y: thirdPage.getHeight() - 381, size: fontSize, font, color: rgb(0, 0, 0), });

            thirdPage.drawText(email, { x: 120, y: thirdPage.getHeight() - 405, size: fontSize, font, color: rgb(0, 0, 0), });

            thirdPage.drawText(`(${alldate})`, { x: 190, y: 214, size: fontSize, font, color: rgb(0, 0, 0), });

            thirdPage.drawText(`(${alldate})`, { x: 440, y: 214, size: fontSize, font, color: rgb(0, 0, 0), });

            thirdPage.drawText(approver, { x: 50, y: 199, size: fontSize, font, color: rgb(0, 0, 0), });

            // thirdPage.drawText(owner, { x: 310, y: 90, size: fontSize, font, color: rgb(0, 0, 0), });


            thirdPage.drawText(alldate, { x: 310, y: 152, size: fontSize, font, color: rgb(0, 0, 0), });

const drawWebsiteText = (label, url, x, y) => {
                const labelText = `${label}[`;

                // Draw label
                fourthPage.drawText(labelText, {
                    x,
                    y,
                    size: fontSize,
                    font,
                    color: rgb(0, 0, 0),
                });

                // Calculate URL position
                const labelWidth = font.widthOfTextAtSize(
                    labelText,
                    fontSize
                );

                const urlX = x + labelWidth + 1 ;

                // Draw URL
                fourthPage.drawText(url, {
                    x: urlX,
                    y,
                    size: fontSize,
                    font,
                    color: rgb(0, 0, 1),
                });

                // URL width
                const urlWidth = font.widthOfTextAtSize(
                    url,
                    fontSize
                );

                // Underline URL
                fourthPage.drawLine({
                    start: {
                        x: urlX,
                        y: y - 2,
                    },
                    end: {
                        x: urlX + urlWidth,
                        y: y - 2,
                    },
                    thickness: 0.7,
                    color: rgb(0, 0, 1),
                });

                // Closing bracket
                fourthPage.drawText(']', {
                    x: urlX + urlWidth + 2,
                    y,
                    size: fontSize,
                    font,
                    color: rgb(0, 0, 0),
                });
            };

            const cutoffDate = new Date('2026-08-01');
            const enrolledDateObj = new Date(enrolleddate);

            if (enrolledDateObj < cutoffDate) {

                // Before August 2026
                drawWebsiteText(
                    'SSG website ',
                    'www.skillsfuture.gov.sg/contact',
                    162,
                    570
                );

            } else {

                // August 2026 onwards
                drawWebsiteText(
                    'SWDA website ',
                    'https://www.swda.gov.sg/',
                    162,
                   570
                );
            }
            

            
            //Mr/Ms
            fifthPage.drawText("_", { x: basedongender, y: firstPage.getHeight() - 239, size: 38, font, color: rgb(0, 0, 0), });
            //Mrs
            fifthPage.drawText("_", { x: 102, y: fifthPage.getHeight() - 239, size: 40, font, color: rgb(0, 0, 0), });
            //NRIC/FIN
            if (proofType === 'NRIC') {
                fifthPage.drawText("__", { x: 257, y: fifthPage.getHeight() - 298, size: 40, font, color: rgb(0, 0, 0), });
            }
            else {
                fifthPage.drawText("_", { x: 217, y: fifthPage.getHeight() - 295, size: 55, font, color: rgb(0, 0, 0), });
            }
            // fifthPage.drawText("__", { x: 207, y: fifthPage.getHeight() - 297, size: 40, font, color: rgb(0, 0, 0), });

            fifthPage.drawText(course, { x: 120, y: fifthPage.getHeight() - 176, size: fontSize, font, color: rgb(0, 0, 0), });

            fifthPage.drawText(`${toUpperCaseString11(studentInfo.scheduleDate)}`, { x: 130, y: fifthPage.getHeight() - 195, size: fontSize, font, color: rgb(0, 0, 0), });

            fifthPage.drawText(studentName, { x: 160, y: fifthPage.getHeight() - 250, size: fontSize, font, color: rgb(0, 0, 0), });

            fifthPage.drawText(gender, { x: 471, y: fifthPage.getHeight() - 286, size: fontSize, font, color: rgb(0, 0, 0), });

            fifthPage.drawText(countryBirth, { x: 140, y: fifthPage.getHeight() - 285, size: fontSize, font, color: rgb(0, 0, 0), });

            fifthPage.drawText(formattedDob, { x: 335, y: fifthPage.getHeight() - 285, size: fontSize, font, color: rgb(0, 0, 0) });

            fifthPage.drawText(nationality, { x: 120, y: fifthPage.getHeight() - 308, size: fontSize, font, color: rgb(0, 0, 0), });

            fifthPage.drawText(nric, { x: 310, y: fifthPage.getHeight() - 308, size: fontSize, font, color: rgb(0, 0, 0), });

            fifthPage.drawText(passportNo, { x: 475, y: fifthPage.getHeight() - 308, size: fontSize, font, color: rgb(0, 0, 0), });

            fifthPage.drawText(company, { x: 140, y: fifthPage.getHeight() - 398, size: fontSize, font, color: rgb(0, 0, 0), });

            fifthPage.drawText(designation, { x: 140, y: fifthPage.getHeight() - 428, size: fontSize, font, color: rgb(0, 0, 0), });

            fifthPage.drawText(addressOffice, { x: 120, y: fifthPage.getHeight() - 455, size: fontSize, font: addressfont, color: rgb(0, 0, 0), });

            fifthPage.drawText(addressHome, { x: 120, y: fifthPage.getHeight() - 500, size: fontSize, font, color: rgb(0, 0, 0), });

            fifthPage.drawText(phoneHome, { x: 103, y: fifthPage.getHeight() - 560, size: fontSize, font, color: rgb(0, 0, 0), });

            fifthPage.drawText(phoneOffice, { x: 263, y: fifthPage.getHeight() - 560, size: fontSize, font, color: rgb(0, 0, 0), });

            fifthPage.drawText(phone, { x: 450, y: fifthPage.getHeight() - 560, size: fontSize, font, color: rgb(0, 0, 0), });

            fifthPage.drawText(email, { x: 95, y: fifthPage.getHeight() - 583, size: fontSize, font, color: rgb(0, 0, 0), });

            fifthPage.drawText(emergencyName, { x: 83, y: fifthPage.getHeight() - 653, size: fontSize, font, color: rgb(0, 0, 0), });

            fifthPage.drawText(emergencyRelation, { x: 296, y: fifthPage.getHeight() - 654, size: fontSize, font, color: rgb(0, 0, 0), });

            fifthPage.drawText(emergencyPhone, { x: 420, y: fifthPage.getHeight() - 653, size: fontSize, font, color: rgb(0, 0, 0), });

            sixthPage.drawText(`$${registrationfee}`, { x: 230, y: sixthPage.getHeight() - 511, size: fontSize, font, color: rgb(0, 0, 0), });

            sixthPage.drawText(paymentType, { x: 300, y: sixthPage.getHeight() - 512, size: fontSize, font, color: rgb(0, 0, 0), });

            sixthPage.drawText(`${nric}-R`, { x: 435, y: sixthPage.getHeight() - 512, size: fontSize, font, color: rgb(0, 0, 0), });

            sixthPage.drawText(': ' + alldate, { x: 455, y: sixthPage.getHeight() - 406.5, size: fontSize, font, color: rgb(0, 0, 0), });

            sixthPage.drawText(`(${alldate})`, { x: 542, y: sixthPage.getHeight() - 732, size: 10, font, color: rgb(0, 0, 0), });

            sixthPage.drawText(`(${alldate})`, { x: 225, y: sixthPage.getHeight() - 732, size: 10, font, color: rgb(0, 0, 0), });

            sixthPage.drawText(owner, { x: 400, y: sixthPage.getHeight() - 750, size: 10, font, color: rgb(0, 0, 0), });

            sixthPage.drawText(approver, { x: 140, y: sixthPage.getHeight() - 750, size: 10, font, color: rgb(0, 0, 0), });

            seventhPage.drawText(owner, { x: 400, y: sixthPage.getHeight() - 545.5, size: 10, font, color: rgb(0, 0, 0), });

            seventhPage.drawText(studentInfo?.intakeId, { x: 370, y: fifthPage.getHeight() - 180, size: fontSize, font, color: rgb(0, 0, 0), });

            // seventhPage.drawText(wrapText2("studentName",), { x: 96, y: fifthPage.getHeight() - 180, size: fontSize, font, color: rgb(0, 0, 0), });
            drawWrappedText(seventhPage, studentName, 92, fifthPage.getHeight() - 179, font, 10, 135);

            seventhPage.drawText(`(${alldate})`, { x: 480, y: seventhPage.getHeight() - 485, size: 9, font, color: rgb(0, 0, 0), });

            seventhPage.drawText(courseFee, {
                x: 182,
                y: seventhPage.getHeight() - 550,
                size: fontSize,
                font,
                color: rgb(0, 0, 0),
            });

            seventhPage.drawText(displayValue, {
                x: 200, // Adjust X position as needed
                y: seventhPage.getHeight() - 570, // Adjust Y position as needed
                size: fontSize,
                font,
                color: rgb(0, 0, 0),
            });

            tenthPage.drawText(alldate, { x: 340, y: 270, size: fontSize, font, color: rgb(0, 0, 0), });

            const tenthPageHeight = tenthPage.getHeight();
            tenthPage.drawText(nric, {
                x: 213,
                y: tenthPageHeight - 345,
                size: fontSize,
                font,
                color: rgb(0, 0, 0),
            });

            tenthPage.drawText(studentName, {
                x: 150,
                y: tenthPageHeight - 303,
                size: fontSize,
                font,
                color: rgb(0, 0, 0),
                maxWidth: 300,
                lineHeight: fontSize * 0.6,
            });

            eleventhPage.drawText(alldate, { x: 478, y: 674, size: fontSize, font, color: rgb(0, 0, 0), });

            // Draw text on the eleventh page
            const eleventhPageHeight = eleventhPage.getHeight();
            eleventhPage.drawText(studentName, {
                x: 120,
                y: eleventhPageHeight - 212,
                size: fontSize,
                font,
                color: rgb(0, 0, 0),
            });

            eleventhPage.drawText(nric, {
                x: 164,
                y: eleventhPageHeight - 244,// Adjust Y position to ensure text visibility
                size: fontSize,
                font,
                color: rgb(0, 0, 0),
            });

            if (proofType === 'NRIC') {
                eleventhPage.drawText("__", { x: 116, y: eleventhPage.getHeight() - 234, size: 40, font, color: rgb(0, 0, 0), });
            }
            else {
                eleventhPage.drawText("_", { x: 75, y: eleventhPage.getHeight() - 231, size: 55, font, color: rgb(0, 0, 0), });
            }

            eleventhPage.drawText(studentName, { x: 155, y: 114, size: fontSize, font, color: rgb(0, 0, 0), });

            // Load and embed the tick icon image
            const tickIconBytes = await fetch(icon).then(res => res.arrayBuffer());
            const tickIconImage = await pdfDoc.embedPng(tickIconBytes);

            // Define scaling factors
            const scaleFirstPage = 0.02; // Scale for the existing tick icons on the first page
            const scaleSixthPage = 0.012; // Scale for the sixth page
            const scaleSeventhPage = 0.014; // Scale for the seventh page
            const separateScaleFirstPage = 0.01; // Scale for the top-right corner tick icon

            // Set scaling factors
            const scaledIconFirstPage = tickIconImage.scale(scaleFirstPage);
            const scaledIconSixthPage = tickIconImage.scale(scaleSixthPage);
            const scaledIconSeventhPage = tickIconImage.scale(scaleSeventhPage);
            const separateScaledIconFirstPage = tickIconImage.scale(separateScaleFirstPage);
            const { width: widthFirstPage, height: heightFirstPage } = scaledIconFirstPage;
            const { width: widthSixthPage, height: heightSixthPage } = scaledIconSixthPage;
            const { width: widthSeventhPage, height: heightSeventhPage } = scaledIconSeventhPage;
            const { width: separateWidthFirstPage, height: separateHeightFirstPage } = separateScaledIconFirstPage;

            // Draw the separate tick icon in the top-right corner of the first page
            if (proofType === "NRIC") {
                firstPage.drawImage(tickIconImage, {
                    x: firstPage.getWidth() - 285, // Adjust X position to be near the top-right corner
                    y: firstPage.getHeight() - 121, // Adjust Y position to be near the top-right corner
                    width: separateWidthFirstPage,
                    height: separateHeightFirstPage,
                });
            }

            if (proofType === "FIN") {
                firstPage.drawImage(tickIconImage, {
                    x: firstPage.getWidth() - 216, // Adjust X position to be near the top-right corner
                    y: firstPage.getHeight() - 121, // Adjust Y position to be near the top-right corner
                    width: separateWidthFirstPage,
                    height: separateHeightFirstPage,
                });
            }

            // Draw existing tick icons or "NA" on the first page
            const firstPageInitialY = firstPage.getHeight() - 188;
            const firstPageRowSpacing = 34;
            for (let i = 0; i < 13; i++) {
                if (i === 2 || i === 7) {
                    continue; // Skip specific rows
                } else if (i === 4 || i === 5) {
                    firstPage.drawText("", {
                        x: 368,
                        y: firstPageInitialY - i * firstPageRowSpacing,
                        size: fontSize,
                        font,
                        color: rgb(1, 0, 0),
                    });
                } else {
                    firstPage.drawImage(tickIconImage, {
                        x: 368,
                        y: firstPageInitialY - i * firstPageRowSpacing,
                        width: widthFirstPage,
                        height: heightFirstPage,
                    });
                }
            }

            // Draw tick icons or "NA" on the sixth page
            const sixthPageInitialY = sixthPage.getHeight() - 597;
            const sixthPageRowSpacing = 15;
            for (let i = 0; i < 5; i++) {
                if (i === 3) {
                    sixthPage.drawText("", {
                        x: 370,
                        y: sixthPageInitialY - i * sixthPageRowSpacing,
                        size: fontSize,
                        font,
                        color: rgb(1, 0, 0),
                    });
                } else {
                    sixthPage.drawImage(tickIconImage, {
                        x: 370,
                        y: sixthPageInitialY - i * sixthPageRowSpacing,
                        width: widthSixthPage,
                        height: heightSixthPage,
                    });
                }
            }

            // Draw tick icons or "NA" on the seventh page
            const seventhPageInitialY = seventhPage.getHeight() - 191;
            const seventhPageRowSpacing = 25;
            for (let i = 0; i < 7; i++) {
                if (i === 4) {
                    seventhPage.drawText("", {
                        x: 355,
                        y: seventhPageInitialY - i * seventhPageRowSpacing,
                        size: fontSize,
                        font,
                        color: rgb(1, 0, 0),
                    });
                } else {
                    seventhPage.drawImage(tickIconImage, {
                        x: 355,
                        y: seventhPageInitialY - i * seventhPageRowSpacing,
                        width: widthSeventhPage,
                        height: heightSeventhPage,
                    });
                }
            }

            const institutionInitialY = sixthPage.getHeight() - 208; // Adjust Y position for initial placement
            const institutionRowSpacing = 25; // Space between rows
            const maxQualificationXPosition = 550; // Max X position for qualifications before wrapping

            const xPositions = {
                institution: 52,
                year: 230,
                fullTimeOrPartTime: 310,
                qualificationsAchieved: 400,
            };

            // Function to handle text wrapping
            const wrapText = (text, maxWidth) => {
                const words = text.split(" ");
                let lines = [];
                let currentLine = words[0];

                for (let i = 1; i < words.length; i++) {
                    const word = words[i];
                    const width = font.widthOfTextAtSize(`${currentLine} ${word}`, fontSize);

                    if (width < maxWidth) {
                        currentLine += ` ${word}`;
                    } else {
                        lines.push(currentLine);
                        currentLine = word;
                    }
                }
                lines.push(currentLine);
                return lines;
            };

            //for knowabouprogram
            let xKnow, yKnow;




            switch (KnowAboutProgram) {
                case 'referral':
                    xKnow = 231; // Set the x position for referral
                    yKnow = 115; // Set the y position for referral
                    break;
                case 'Jurong Academy Website':
                    xKnow = 231; // Set the x position for Jurong Academy Website
                    yKnow = 140; // Set the y position for Jurong Academy Website
                    break;
                case 'Flyers':
                    xKnow = 42; // Set the x position for Flyers
                    yKnow = 115; // Set the y position for Flyers
                    break;
                case 'Newspaper Advertisement':
                    xKnow = 42; // Set the x position for Newspaper Advertisement
                    yKnow = 140; // Set the y position for Newspaper Advertisement
                    break;
                case 'other':
                    xKnow = 231; // Set the x position for other
                    yKnow = 115; // Set the y position for other
                    break;
                default:
                    xKnow = 231; // Set default x position
                    yKnow = 140; // Set default y position
            }

            const separateScaleF = 0.02;
            const separateScaledIconF = tickIconImage.scale(separateScaleF);
            const { width: separateWidthF, height: separateHeightF } = separateScaledIconF;

            // fifthPage.drawText(icon, { x: xKnow, y: yKnow, size: fontSize, font, color: rgb(0, 0, 0), });
            fifthPage.drawImage(tickIconImage, {
                x: xKnow, // Adjust X position to be near the top-right corner
                y: yKnow, // Adjust Y position to be near the top-right corner
                width: separateWidthF,
                height: separateHeightF,
            });

            fifthPage.drawText(otherDetails, { x: 298, y: fifthPage.getHeight() - 728, size: fontSize, font, color: rgb(0, 0, 0), });
            fifthPage.drawText(referalfriend, { x: 300, y: fifthPage.getHeight() - 725, size: fontSize, font, color: rgb(0, 0, 0), });



            institutionDetails.forEach((detail, index) => {
                const { institution, year, fullTimeOrPartTime, qualificationsAchieved } = detail;

                // Wrap institution name if it exceeds the max x-position
                const institutionLines = wrapText(institution, xPositions.year - xPositions.institution);

                institutionLines.forEach((line, lineIndex) => {
                    sixthPage.drawText(line, {
                        x: xPositions.institution,
                        y: institutionInitialY - index * institutionRowSpacing - lineIndex * fontSize,
                        size: fontSize,
                        font,
                        color: rgb(0, 0, 0),
                    });
                });

                // Draw the remaining details, adjusting for wrapped lines
                const institutionYOffset = institutionLines.length > 1 ? (institutionLines.length - 1) * fontSize : 0;

                sixthPage.drawText(`${year}`, {
                    x: xPositions.year,
                    y: institutionInitialY - index * institutionRowSpacing - institutionYOffset,
                    size: fontSize,
                    font,
                    color: rgb(0, 0, 0),
                    maxWidth: 50,
                    lineHeight: fontSize * 1.1,
                });

                sixthPage.drawText(`${fullTimeOrPartTime}`, {
                    x: xPositions.fullTimeOrPartTime,
                    y: institutionInitialY - index * institutionRowSpacing - institutionYOffset,
                    size: fontSize,
                    font,
                    color: rgb(0, 0, 0),
                });

                // Wrap qualifications if it exceeds the max x-position
                const qualificationLines = wrapText(qualificationsAchieved, maxQualificationXPosition - xPositions.qualificationsAchieved);

                qualificationLines.forEach((line, lineIndex) => {
                    sixthPage.drawText(line, {
                        x: xPositions.qualificationsAchieved,
                        y: institutionInitialY - index * institutionRowSpacing - lineIndex * fontSize, // No institutionYOffset here
                        size: fontSize,
                        font,
                        color: rgb(0, 0, 0),
                    });
                });
            });


            // Save the modified PDF
            const pdfBytesModified = await pdfDoc.save();
            const pdfBlob = new Blob([pdfBytesModified], { type: 'application/pdf' });
            const pdfUrl = URL.createObjectURL(pdfBlob);
            window.open(pdfUrl, '_blank');
        } catch (error) {
            console.error('Error generating PDF:', error);
        }
    };

    // const formatDate = (dateString) => {
    //     const date = new Date(dateString);
    //     const day = String(date.getDate()).padStart(2, '0');
    //     const month = String(date.getMonth() + 1).padStart(2, '0');
    //     const year = date.getFullYear();
    //     return `${day}/${month}/${year}`;
    // };

    const extractDate = (dateStr) => {
        const date = new Date(dateStr);
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-indexed
        const day = String(date.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
    };

    const toUpperCaseString11 = (dateString) => {
        const date = new Date(dateString);
        const month = getMonthName(date.getMonth());
        const year = date.getFullYear();
        return `${month} ${year}`;
    };

    const getMonthName = (monthNumber) => {
        const monthNames = [
            "JANUARY", "FEBRUARY", "MARCH", "APRIL", "MAY", "JUNE",
            "JULY", "AUGUST", "SEPTEMBER", "OCTOBER", "NOVEMBER", "DECEMBER"
        ];
        return monthNames[monthNumber];
    };


    function removeFirstTwoNumbersAfterDash(input) {
        // Split the input string into two parts at the first '-'
        const [prefix, suffix] = input.split('-');

        // Remove the first two numbers from the suffix
        const modifiedSuffix = suffix.replace(/^\d{2}/, '');

        // Recombine the prefix and modified suffix
        return `${prefix}-${modifiedSuffix}`;
    }




    useImperativeHandle(ref, () => ({ handleDownload }));

    return null;
});

export default ApplicationForm;
